import { render, staticRenderFns } from "./ValutazioneTabB.vue?vue&type=template&id=144390b0&"
import script from "./ValutazioneTabB.vue?vue&type=script&lang=js&"
export * from "./ValutazioneTabB.vue?vue&type=script&lang=js&"
import style0 from "./ValutazioneTabB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports